//import I18n from "i18n-js/index.js.erb"


var ReservationSettingErrors = {

  general: function (errors) {
    var err = []

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i])
      }
    }

    if (errors && errors["reservation_setting.check_in_time"] && errors["reservation_setting.check_in_time"].length) {
      for (var i = 0, ilen = errors["reservation_setting.check_in_time"].length; i < ilen; i++) {
        err.push(I18n.t('check_in_time') + ' ' + errors["reservation_setting.check_in_time"][i])
      }
    }

    if (errors && errors["reservation_setting.check_out_time"] && errors["reservation_setting.check_out_time"].length) {
      for (var i = 0, ilen = errors["reservation_setting.check_out_time"].length; i < ilen; i++) {
        err.push(I18n.t('check_out_time') + ' ' + errors["reservation_setting.check_out_time"][i])
      }
    }

    if (errors.minimum_stay && errors.minimum_stay.length) {
      for (var i = 0, ilen = errors.minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('minimum_stay') + ' ' + errors.minimum_stay[i])
      }
    }

    if (errors && errors["reservation_setting.maximum_stay"] && errors["reservation_setting.maximum_stay"].length) {
      for (var i = 0, ilen = errors["reservation_setting.maximum_stay"].length; i < ilen; i++) {
        err.push(I18n.t('maximum_stay') + ' ' + errors["reservation_setting.maximum_stay"][i])
      }
    }

    return err
  }

}

export default ReservationSettingErrors
